import { Loader } from 'react-feather'
import { TooltipRenderProps } from 'react-joyride'

const JoyrideTooltip = ({ step, tooltipProps, onDismiss }: TooltipRenderProps & { onDismiss: () => void }) => {
  return (
    <div className='flex items-center justify-center relative -left-16 top-0'>
      <Loader size={16} className='animate-spin mr-4' color='black' />
      <div
        {...tooltipProps}
        className='relative flex items-center justify-center gap-2 bg-black text-white p-2 rounded-md font-medium text-sm'
      >
        <div className='absolute -left-[6px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-[6px] border-t-transparent border-b-[6px] border-b-transparent border-r-[6px] border-r-black' />
        <span>{step.content}</span>
        <button onClick={onDismiss} className='bg-none border-none text-white cursor-pointer py-0 px-1'>
          ×
        </button>
      </div>
    </div>
  )
}

export default JoyrideTooltip
